/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';





const activityTypeApi = async (): Promise<any> => {
    const token = useUserStore.getState().userToken;
    const {setActivityTypes} = useJSONStore.getState();

    try {
        const response = await axios.request({
            method: CRUDMethods.GET,
            url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.activityType}`,
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        
        setActivityTypes(response.data.data);

    } catch (err) {
        console.log('err:', err);
        setActivityTypes([]);
    }
};


export default activityTypeApi;
